<div class="p-4 md:p-8" style="max-width: 520px; margin: 0 auto;">

  <!-- Header -->
  <div style="display: flex; align-items: center; justify-content: center; gap: 10px; margin-bottom: 24px;">
    <img src="assets/flags/venezuela.png" alt="VES" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;">
    <h1 style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; margin: 0;">Comprar bolívares</h1>
  </div>

  <!-- Saldos -->
  <div class="grid grid-cols-2" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
    <div style="padding: 14px 16px; text-align: center; border-right: 1px solid #e5e7eb;">
      <div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
        <img src="assets/flags/chile.png" alt="CLP" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Saldo CLP</span>
      </div>
      <p style="font-size: 1.05rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">${{ formatClp(saldoClp) }}</p>
      <p style="font-size: 0.68rem; color: #6b7280; margin: 2px 0 0;">Puede variar si tienes operaciones CLP en curso</p>
    </div>
    <div style="padding: 14px 16px; text-align: center;">
      <div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
        <img src="assets/flags/venezuela.png" alt="VES" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Saldo VES</span>
      </div>
      <p style="font-size: 1.05rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">Bs. {{ formatVes(saldoVes) }}</p>
    </div>
  </div>

  <!-- ═══ Paso 1: monto ═══ -->
  <div *ngIf="paso === 'monto'" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 24px; margin-bottom: 20px;">
    <label for="montoClpCompraVes" style="display: block; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
      Monto en CLP a usar
    </label>
    <div style="position: relative;">
      <span style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.85rem; pointer-events: none;">CLP</span>
      <input id="montoClpCompraVes" type="text" inputmode="numeric" appMonto [decimales]="0"
        [(ngModel)]="montoClp"
        (ngModelChange)="onMontoChange()"
        placeholder="0"
        class="calc-input"
        style="width: 100%; padding: 14px 80px 14px 60px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box;">
      <button type="button" (click)="usarMaximo()"
        style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 12px; font-size: 0.75rem; font-weight: 700; cursor: pointer;">
        MÁX.
      </button>
    </div>

    <!-- Cotización del servidor -->
    <div style="margin-top: 20px; padding: 16px; background: #f0fdf4; border-radius: 12px;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Recibes en tu saldo VES</span>
      <p style="font-size: 1.5rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 0;">
        <ng-container *ngIf="cotizando">Cotizando…</ng-container>
        <ng-container *ngIf="!cotizando">Bs. {{ formatVes(cotizacion?.montoVes) }}</ng-container>
      </p>
      <p *ngIf="cotizacion" style="font-size: 0.78rem; color: #166534; margin: 6px 0 0;">
        Tasa: $1.000 CLP = Bs. {{ formatVes((cotizacion.tasa || 0) * 1000) }}
      </p>
    </div>

    <p *ngIf="incierto" style="font-size: 0.82rem; color: #b45309; background: #fef3c7; padding: 10px 12px; border-radius: 10px; margin: 12px 0 0;">
      Tu última compra quedó sin respuesta y puede haberse hecho. Revisa tus movimientos VES: si confirmas de nuevo no se cobrará dos veces.
    </p>
    <p *ngIf="montoInvalido" style="font-size: 0.82rem; color: #dc2626; margin: 12px 0 0;">{{ montoInvalido }}</p>
    <p *ngIf="error" style="font-size: 0.82rem; color: #dc2626; margin: 12px 0 0;">{{ error }}</p>

    <button type="button" class="btn-primario" style="margin-top: 20px;" [disabled]="!puedeContinuar" (click)="irAConfirmar()">
      Continuar
    </button>
  </div>

  <!-- ═══ Paso 2: confirmar ═══ -->
  <div *ngIf="paso === 'confirmar' && cotizacion" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 24px; margin-bottom: 20px;">
    <h2 style="font-size: 1rem; font-weight: 700; color: #1f2937; margin: 0 0 12px;">Confirma tu compra</h2>
    <div class="fila">
      <span style="font-size: 0.85rem; color: #6b7280;">Se descuenta de tu saldo CLP</span>
      <span style="font-weight: 700; color: #1f2937;">${{ formatClp(montoClp) }}</span>
    </div>
    <div class="fila">
      <span style="font-size: 0.85rem; color: #6b7280;">Tasa</span>
      <span style="font-weight: 600; color: #1f2937;">$1.000 CLP = Bs. {{ formatVes(cotizacion.tasa * 1000) }}</span>
    </div>
    <div class="fila">
      <span style="font-size: 0.85rem; color: #6b7280;">Recibes en tu saldo VES</span>
      <span style="font-weight: 800; color: #1e5a3f;">Bs. {{ formatVes(cotizacion.montoVes) }}</span>
    </div>
    <p style="font-size: 0.78rem; color: #6b7280; margin: 14px 0 0;">
      La compra es inmediata y los bolívares quedan en tu saldo VES. Desde ahí puedes enviarlos a un
      beneficiario en Venezuela, pasarlos a pesos a tu cuenta en Chile o convertirlos a USDT.
    </p>

    <p *ngIf="aviso" style="font-size: 0.82rem; color: #b45309; background: #fef3c7; padding: 10px 12px; border-radius: 10px; margin: 14px 0 0;">{{ aviso }}</p>
    <p *ngIf="error" style="font-size: 0.82rem; color: #dc2626; background: #fef2f2; padding: 10px 12px; border-radius: 10px; margin: 14px 0 0;">{{ error }}</p>

    <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 20px;">
      <button type="button" class="btn-primario" [disabled]="comprando || cotizando" (click)="confirmar()">
        {{ comprando ? 'Comprando…' : (incierto ? 'Reintentar compra' : 'Comprar bolívares') }}
      </button>
      <button type="button" *ngIf="incierto" class="btn-secundario" [disabled]="comprando" (click)="irAMovimientos()">
        Ver mis movimientos VES
      </button>
      <button type="button" class="btn-secundario" [disabled]="comprando" (click)="volver()">Volver</button>
    </div>
  </div>

  <!-- ═══ Paso 3: listo ═══ -->
  <div *ngIf="paso === 'listo' && resultado" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 24px; margin-bottom: 20px; text-align: center;">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #16a34a;">check_circle</mat-icon>
    <h2 style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f; margin: 8px 0 4px;">Compra realizada</h2>
    <p style="font-size: 0.9rem; color: #374151; margin: 0 0 16px;">
      Compraste <strong>Bs. {{ formatVes(resultado.montoVes) }}</strong> con ${{ formatClp(resultado.montoClp) }} CLP.
    </p>
    <div class="fila" style="text-align: left;">
      <span style="font-size: 0.85rem; color: #6b7280;">Nuevo saldo VES</span>
      <span style="font-weight: 700; color: #1f2937;">Bs. {{ formatVes(resultado.balanceVes) }}</span>
    </div>
    <div class="fila" style="text-align: left;">
      <span style="font-size: 0.85rem; color: #6b7280;">Referencia</span>
      <span style="font-size: 0.78rem; font-family: monospace; color: #374151; overflow-wrap: anywhere;">{{ resultado.referenceId }}</span>
    </div>
    <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 20px;">
      <button type="button" class="btn-primario" (click)="irAMovimientos()">Ver mis movimientos VES</button>
      <button type="button" class="btn-secundario" (click)="nuevaCompra()">Hacer otra compra</button>
    </div>

    <!-- Qué puede hacer con el saldo VES (las salidas que Nest habilita al chileno). -->
    <p style="font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin: 20px 0 8px; text-align: left;">¿Qué puedes hacer con tus bolívares?</p>
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <button type="button" class="btn-secundario" (click)="irA('/wallet/client/withdraw-ves')">Enviar a un beneficiario en Venezuela</button>
      <button type="button" class="btn-secundario" (click)="irA('/wallet/client/enviar', { origen: 'VES', destino: 'CL' })">Pasar a pesos a mi cuenta en Chile</button>
      <button type="button" class="btn-secundario" (click)="irA('/wallet/client/convert-ves-usdt')">Convertir a USDT</button>
    </div>
  </div>

</div>
